export const ACTIVE_PAGE_INDEX = 0;
